export default __webpack_public_path__ + "static/media/emptyTopupHistory.a6094610.svg";